import React from "react";
import "./SkeletonLoaderStyles.css";
export default function SkeletonLoader() {
  return (
    <>
      <div className="card" aria-hidden="true">
        <div className="card-body">
          <br />
          <div
            className="card-text placeholder-glow"
            style={{ marginLeft: "30px" }}
          >
            <div style={{ display: "flex" }}>
              <div className="col-1">
                <span
                  className="placeholder col-6 bg-secondary"
                  style={{ height: "60px" }}
                ></span>
              </div>
              <div className="col-11">
                <span className="placeholder col-7 bg-secondary"></span>
                <br />
                <span className="placeholder col-10 placeholder-xs bg-secondary"></span>
                <br />
                <span className="placeholder col-8 placeholder-xs bg-secondary"></span>
              </div>
            </div>
            <br />
            <span className="placeholder col-12 placeholder-xs bg-secondary"></span>
            <br />
            <span
              className="placeholder col-2 placeholder-xs bg-secondary"
              style={{ marginLeft: "170px" }}
            ></span>
          </div>
        </div>
      </div>
    </>
  );
}
